import React, { useEffect, useRef } from 'react';
import { ArrowLeft, Orbit } from 'lucide-react';
import { Button } from 'src/common';
import 'src/common/styles/global.css';
import { createSceneRenderer } from './renderer';
import { loadScene, populateScene } from './loader';

interface BezPlusProps {
  onBack: () => void;
}

export function BezPlus({ onBack }: BezPlusProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !containerRef.current) return;
    initializedRef.current = true;

    const { scene, start, mount } = createSceneRenderer();
    mount(containerRef.current);
    const sceneData = loadScene();
    populateScene(scene, sceneData);
    start();
  }, []);

  return (
    <div className="fixed inset-0 bg-background z-50 flex flex-col text-foreground">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={onBack}>
            <ArrowLeft className="w-5 h-5 text-gray-400" />
          </Button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 shrink-0 bg-purple-500 rounded-lg flex items-center justify-center">
              <Orbit className="w-4 h-4" />
            </div>
            <div className="h-10">
              <h1 className="!text-base font-medium !leading-none">Bez Plus</h1>
              <p className="text-xs text-muted-foreground !leading-none">3D Satellite Scene Viewer</p>
            </div>
          </div>
        </div>
      </div>

      <div ref={containerRef} className="flex-1 overflow-hidden" />
    </div>
  );
}
